import { render, staticRenderFns } from "./Vendedor.vue?vue&type=template&id=3a4eb2b4&scoped=true&"
import script from "./Vendedor.vue?vue&type=script&lang=js&"
export * from "./Vendedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4eb2b4",
  null
  
)

export default component.exports